export class filterParameter {
    accountNumber: string;
    customerId: string;
    emailId: string;
    locationId: string;    
    path: string;
    isStatusSaveOnDB: string;
}